import MonthPanel from './month-panel';

export default MonthPanel;
